// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textEllipsis {
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}

.customchip {
  font-size: 12px;
  min-height: 24px !important;
}

::ng-deep.mat-chip-list {
  display: inline-block;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix {
  padding-inline: 5px;
  padding-block: 1px;
  padding-top: 0px !important;
  min-height: 40px !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list {
  display: inline-block;
}

.examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 133.33333%;
}

.mat-form-field-appearance-fill .mat-form-field-flex {
  border-radius: 4px 4px 0 0;
  padding: 0em 0.75em 0 0.75em !important;
}

.customoption {
  font-size: 13px !important;
  height: 32px !important;
}

.NgxEditor__Wrapper .angular-editor .angular-editor-wrapper .angular-editor-textarea {
  background-color: transparent !important;
  border: 1px solid #ddd !important;
  min-height: 180px !important;
  max-height: 180px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding: 0.5rem 0.8rem 1rem !important;
  position: relative !important;
}

.downloadattach {
  background-color: #17a0b4 !important;
  color: #fff !important;
  border-radius: 20px;
  padding-bottom: 2px;
  padding-inline: 7px;
  font-size: 12px;
  padding-top: 3px;
  cursor: pointer;
}

.link_highlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.link_highlight:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb;
  padding-inline: 3%;
  padding-block: 2px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

.project_label_title {
  position: absolute;
  padding-inline: 5px;
  font-size: 10px;
  top: -10px;
}

.saveVendormodal .modal-dialog {
  max-width: 90% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

.saveVendormodal {
  top: 4% !important;
}

.edit_btn {
  padding-inline: 8px;
}

.font_ellipsis_project {
  font-size: 13px;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  white-space: nowrap;
}

.subject {
  width: 100%;
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  background-color: whitesmoke;
  border-bottom-width: thin;
  padding: 5px;
  font-weight: bold;
}

::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: #ebebeb !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: #ebebeb !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  display: flex !important;
  padding-top: 5px !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px !important;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper {
  background-color: #ebebeb !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: #ebebeb !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  display: flex !important;
  padding-top: 5px !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px !important;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
::ng-deep.mailmatchipstyles .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/mail/mail.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AACA;EAEI,eAAA;EACA,2BAAA;AACJ;;AAEI;EACE,qBAAA;AACN;;AAEI;EACE,mBAAA;EACE,kBAAA;EACA,2BAAA;EACA,2BAAA;AACR;;AAAI;EAEG,qBAAA;AAEP;;AACI;EACI,yCAAA;EACA,iBAAA;AAER;;AAAI;EACE,0BAAA;EACA,uCAAA;AAGN;;AADI;EACE,0BAAA;EACF,uBAAA;AAIJ;;AADA;EACE,wCAAA;EACA,iCAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,sCAAA;EACA,6BAAA;AAIF;;AADA;EAEE,oCAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAGF;;AADA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAIF;;AAFA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAKF;;AADA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAIF;;AADA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAIF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACI,mBAAA;AAKJ;;AAFA;EACE,eAAA;EAAgB,uBAAA;EAAwB,cAAA;EAAe,gBAAA;EAAiB,mBAAA;AAS1E;;AAPA;EACE,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,4BAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AAUF;;AANE;EACE,oCAAA;AASJ;AARI;EACE,wBAAA;AAUN;AARI;EACE,oCAAA;AAUN;AARI;EACE,wBAAA;EACA,2BAAA;AAUN;AATM;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAWR;AATM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAWR;AAVQ;EACE,0BAAA;AAYV;AANI;EACA,oCAAA;AAQJ;AAPI;EACE,wBAAA;AASN;AAPI;EACE,oCAAA;AASN;AAPI;EACE,wBAAA;EACA,2BAAA;AASN;AARM;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAUR;AARM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAUR;AATQ;EACE,0BAAA;AAWV;AANI;EACE,wBAAA;AAQN;AALE;EACE,wBAAA;AAOJ","sourcesContent":[".textEllipsis{\r\n    text-overflow: ellipsis;\r\n    overflow-x: hidden;\r\n    white-space: nowrap;\r\n}\r\n.customchip\r\n  {\r\n    font-size: 12px;\r\n    min-height: 24px !important;\r\n  }\r\n\r\n    ::ng-deep.mat-chip-list{\r\n      display:inline-block ;\r\n    }\r\n\r\n    .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix  {\r\n      padding-inline: 5px ;\r\n        padding-block: 1px ;\r\n        padding-top: 0px !important;\r\n        min-height: 40px !important ; }\r\n    .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list\r\n    {\r\n       display: inline-block;\r\n      }\r\n\r\n    .examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n        transform: translateY(-1.1em) scale(.75);\r\n        width: 133.33333%;\r\n    }\r\n    .mat-form-field-appearance-fill .mat-form-field-flex {\r\n      border-radius: 4px 4px 0 0;\r\n      padding: 0em 0.75em 0 0.75em !important;\r\n    }\r\n    .customoption{\r\n      font-size: 13px !important;\r\n    height: 32px !important;\r\n}\r\n\r\n.NgxEditor__Wrapper .angular-editor .angular-editor-wrapper .angular-editor-textarea{\r\n  background-color: transparent !important;\r\n  border: 1px solid #ddd !important;\r\n  min-height: 180px !important;\r\n  max-height: 180px !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  padding: 0.5rem 0.8rem 1rem !important;\r\n  position: relative !important;\r\n}\r\n\r\n.downloadattach\r\n{\r\n  background-color: #17a0b4 !important;\r\n  color: #fff !important;\r\n  border-radius: 20px;\r\n  padding-bottom: 2px;\r\n  padding-inline: 7px;\r\n  font-size: 12px;\r\n  padding-top: 3px;\r\n  cursor: pointer;\r\n}\r\n.link_highlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n.link_highlight:hover{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  background-color: #3fa4fb;\r\n  padding-inline: 3%;\r\n  padding-block: 2px;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.project_label_title{\r\n  position: absolute;\r\n  padding-inline: 5px;\r\n  font-size: 10px;\r\n  top: -10px;\r\n}\r\n\r\n.saveVendormodal .modal-dialog {\r\n  max-width: 90%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n.saveVendormodal{\r\n  top: 4%!important;\r\n}\r\n\r\n.edit_btn{\r\n    padding-inline: 8px;\r\n}\r\n\r\n.font_ellipsis_project{\r\n  font-size: 13px;text-overflow: ellipsis;display: block;overflow: hidden;white-space: nowrap;\r\n}\r\n.subject{\r\n  width: 100%;\r\n  border-top-color: transparent;\r\n  border-left-color: transparent;\r\n  border-right-color: transparent;\r\n  background-color: whitesmoke;\r\n  border-bottom-width: thin;\r\n  padding: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n::ng-deep.mailmatchipstyles .mat-mdc-form-field{\r\n  .mat-mdc-text-field-wrapper{\r\n    background-color: #ebebeb !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: #ebebeb !important;\r\n    }\r\n    .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n      display: flex !important;\r\n      padding-top: 5px  !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 12px !important;\r\n        width: 150px !important;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .mat-focused {\r\n    .mat-mdc-text-field-wrapper{\r\n    background-color: #ebebeb !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: #ebebeb !important;\r\n    }\r\n    .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n      display: flex !important;\r\n      padding-top: 5px  !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 12px !important;\r\n        width: 150px !important;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n        }\r\n      }\r\n    }\r\n    }\r\n    .mat-mdc-form-field-subscript-wrapper{\r\n      display: none !important;\r\n    }\r\n  }\r\n  .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
